import styled from 'styled-components';
import { CenterRowDiv, ColDiv, Div, RowDiv, theme } from 'styles';

export const InfoDiv = styled(CenterRowDiv)`
  margin-top: 32px;
  border-radius: 8px;
  height: 29px;
  padding: 0 8px;
  gap: 8px;
  background-color: ${theme.colors.gray50};
`;

export const ControlList = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 32px 0;
  padding: 12px 0;

  li {
    display: flex;
    height: 82px;
    position: relative;
    border-radius: 8px;
    padding: 0 24px;
    transition: background-color 150ms ease;
  }

  li:nth-child(8n + 1),
  li:nth-child(8n + 2),
  li:nth-child(8n + 3),
  li:nth-child(8n + 4) {
    margin-bottom: 12px;
  }

  li:nth-child(8n + 5),
  li:nth-child(8n + 6),
  li:nth-child(8n + 7),
  li:nth-child(8n + 8) {
    margin-top: 12px;
  }

  li:nth-child(8n + 5):before,
  li:nth-child(8n + 6):before,
  li:nth-child(8n + 7):before,
  li:nth-child(8n + 8):before {
    content: '';
    display: inline-block;
    position: absolute;
    top: -12px;
    width: 100%;
    height: 1px;
    background-color: ${theme.colors.gray100};
  }

  li:not(:nth-last-child(1)):not(:nth-child(4n)) {
    border-right: 1px solid ${theme.colors.gray100};
  }

  li:nth-last-child(1),
  li:nth-child(4n) {
    padding-right: 0;
  }
`;

export const HoverDiv = styled(RowDiv)`
  border-radius: 8px;
  width: 100%;
  padding: 16px 0;
  cursor: pointer;
  transition: background-color 150ms ease;

  &:hover {
    background-color: ${theme.colors.fill02};
  }
`;

export const ConDiv = styled(ColDiv)`
  flex: 1;
  padding-left: 8px;
  align-items: flex-end;
  height: 50px;

  & > p {
    width: 100%;
    text-align: start;
    padding-bottom: 2px;
  }
`;

export const ModalTimeDiv = styled(CenterRowDiv)`
  width: 162px;
  height: 56px;
  padding: 15px 11px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.fill12};

  &:hover {
    border: 1px solid ${theme.colors.gray500};
    background-color: #ffffff;
  }

  &:active,
  &:focus-within {
    border: 1px solid ${theme.colors.primary};
    background-color: #ffffff;
    box-shadow: ${theme.shadows.input};
  }
`;
